import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import { Route, Link } from 'react-router-dom';
import { Slot } from 'react-slot-fill';
import styles from './AuthLayout.css';
import appStyles from '../styles/app.css';
import Logo from '../Components/Logo';
import PoweredByLogo from '../Components/PoweredByLogo';
import SITE_MODES from '../../constants/site-modes';

const LogoShow = ({ onboarding }) => {
    if (onboarding) {
        return null;
    }
    return (
        <PoweredByLogo />
    );
};

LogoShow.propTypes = {
    onboarding: PropTypes.bool,
};

const AuthLayout = ({
    component: Component,
    title,
    companyName,
    companyDomain,
    siteMode,
    onboarding,
    ...other
}) => (<Route
    {...other}
    render={matchProps => (<div
        className={cx(styles.wrap, {
            [appStyles.bg]: siteMode === SITE_MODES.EDUCATION,
        })}
    >
        <Helmet>
            <title>
                {title ? `${title} | ` : ''}
                {siteMode === SITE_MODES.EDUCATION ? 'PathwayU' : 'jobZology'}
            </title>
        </Helmet>
        <main className={styles.container}>
            <div className={styles.header}>
                <Link
                    to={'/login'}
                    className={styles.logo}
                    aria-label={companyName}
                >
                    <Logo />
                </Link>
                <div className={styles.desktop}>
                    {(companyDomain !== 'app' || companyDomain !== 'whitman') ? (<Slot
                        name="PoweredBy"
                    >
                        {slots => (slots && slots[0] ?
                            slots[0] : <LogoShow onboarding={(onboarding || companyDomain === 'whitman')} />
                        )}
                    </Slot>) : null }
                </div>
            </div>
            <Component {...matchProps} />
            <Slot name="AuthFooter" />
            {(companyDomain !== 'whitman' || !onboarding) && (<div className={styles.mobile}>
                <Slot
                    name="PoweredBy"
                >
                    {slots => (slots && slots[0] ?
                        slots[0] : <div />
                    )}
                </Slot>
            </div>)}
        </main>
    </div>)}
/>);


AuthLayout.propTypes = {
    title: PropTypes.string,
    companyName: PropTypes.string,
    onboarding: PropTypes.bool,
    companyDomain: PropTypes.string,
    siteMode: PropTypes.number,
    component: PropTypes.func,
};

export default connect(({ theme }, location) => ({
    onboarding: ('token' in queryString.parse(location.search)),
    siteMode: theme.siteMode,
    companyName: theme.companyName,
    companyDomain: theme.companyDomain,
}))(AuthLayout);



// WEBPACK FOOTER //
// ./src/client/Layouts/AuthLayout.js